import React, {useContext} from 'react'
import {Collapse} from "@material-ui/core";
import FormTranslationContext from "context/FormTranslationContext";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import NoticeYesNoInput from "../../components/inputs/NoticeYesNoInput";
import NoticeNumericInput from "../../components/inputs/NoticeNumericInput";
import NoticeIntegerInput from "../../components/inputs/NoticeIntegerInput";
import OrderObjectNotDivided from "./OrderObjectNotDivided";
import OrderObjectDivided from "./OrderObjectDivided";
import Typography from "components/Typography";
import getObjectValue from "libs/getObjectValue";

function OrderObjectData(
    {
        id,
        formikProps
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const {getDict} = useContext(FormTranslationContext)
    const updateNotice = getObjectValue('_updateNotice', formikProps.values, true);
    const basicDataRefersTo = gVal("form.basicData.refersTo", false);

    return (<>

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("number")}
        />

        <NoticeGlossaryInput
            id={gId("orderType")}
            formikProps={formikProps}
            items={getDict("ENUM.002")}
            required
        />

        <Collapse in={basicDataRefersTo === "Order"}>

            <NoticeYesNoInput
                formikProps={formikProps}
                id={gId("dividedIntoLots")}
            />

            <NoticeNumericInput
                formikProps={formikProps}
                id={gId("lotsValueNet")}
                required
            />

            <NoticeGlossaryInput
                id={gId("lotsValueNetCurrency")}
                formikProps={formikProps}
                items={getDict("SL.MO.043")}
            />

            <Collapse in={gVal("dividedIntoLots") === true}>
                <NoticeNumericInput
                    formikProps={formikProps}
                    id={gId("orderValueNet")}
                />

                <NoticeGlossaryInput
                    id={gId("orderValueNetCurrency")}
                    formikProps={formikProps}
                    items={getDict("SL.MO.043")}
                />
            </Collapse>
        </Collapse>

        <Collapse in={basicDataRefersTo === "FrameworkAgreement"}>
            <NoticeNumericInput
                formikProps={formikProps}
                id={gId("frameworkAgreementValueNet")}
            />

            <NoticeGlossaryInput
                id={gId("frameworkAgreementValueNetCurrency")}
                formikProps={formikProps}
                items={getDict("SL.MO.043")}
            />
        </Collapse>

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("partialOffers")}
            required
            disabled={updateNotice}
        />

        <Collapse in={gVal("partialOffers") === true}>
            <Typography>To pole uzupełniane jest automatycznie poprzez dodawanie kolejnych części poniżej</Typography>
            <NoticeIntegerInput
                formikProps={formikProps}
                id={gId("dealingCount")}
                disabled
                required
            />

        </Collapse>

        <Collapse in={gVal("partialOffers") === false} unmountOnExit>
            <OrderObjectNotDivided id={gId("notDivided")} formikProps={formikProps} />
        </Collapse>

        <Collapse in={gVal("partialOffers") === true} unmountOnExit>
            <OrderObjectDivided id={id} formikProps={formikProps}/>
        </Collapse>

    </>)
}

OrderObjectData.propTypes = {};

export default OrderObjectData;
